/* eslint-disable import/prefer-default-export */
import { optionsAutomation } from '@modules/theme/helpers/menuAutomation';
import { optionsCategory } from './menuCategory';
import { optionsMasterBrand } from './menuMasterBrand';
import { optionsClient } from '@modules/theme/helpers/menuClient';
import { optionsApiLog } from '@modules/theme/helpers/menuApiLog';
import { optionsStore } from '@modules/theme/helpers/menuStore';

export const helpersMenuList = (t) => [
    ...optionsAutomation(t),
    ...optionsCategory(t),
    ...optionsMasterBrand(t),
    ...optionsClient(t),
    ...optionsStore(t),
    ...optionsApiLog(t),
];
